// `/home` restores the tab the user was last on from `lscache-twProjects-last-home-section`.
// A stale value naming a tab we no longer serve (inbox, comments and messages all moved to
// the Lightspeed Inbox) would bounce off the catch-all back to `/home` forever, so only
// sections still listed below are restored.
const homeSections = ['work', 'calendar', 'projects', 'activity', 'events', 'dashboards', 'planner', 'shortcuts'];

export default [
  {
    path: '/home',
    component: () => import('./RouteHome'),
    children: [
      {
        path: '',
        redirect() {
          const lastSection = window.localStorage.getItem('lscache-twProjects-last-home-section');
          return `/home/${homeSections.includes(lastSection) ? lastSection : 'work'}`;
        },
      },
      {
        path: 'work',
        component: () => import('./RouteHomeWork'),
        meta: {
          noSpacing: true,
        },
      },
      {
        path: 'calendar',
        component: () => import('@sections/Idle'),
      },
      {
        path: 'projects',
        component: () => import('./RouteHomeProjects'),
      },
      {
        path: 'activity',
        component: () => import('./RouteHomeActivity'),
      },
      {
        path: 'events',
        component: () => import('./RouteHomeEvents'),
      },
      {
        path: 'dashboards',
        component: () => import('./RouteHomeDashboards'),
      },
      {
        path: 'planner',
        component: 'planning-workload',
        meta: {
          permission: {
            id: 'canAccessWorkloadPlannerTab',
            redirect: '/planning/chart',
          },
          noSpacing: true,
          name: 'workload',
          pageName: 'Workload',
          isPlanningPage: true, // temporary TKO hack
          canViewFullScreen: true,
          menuPermission: 'canAccessWorkloadPlannerTab',
        },
      },
      {
        path: 'shortcuts',
        component: () => import('./RouteHomeShortcuts'),
      },
      {
        path: '*',
        redirect: '/home',
      },
    ],
  },
];
